import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "layout": "horizontal",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "model": _vm.formState
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "md": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "标题",
      "prop": "formName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: _vm.formState.formName,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "formName", $$v);
      },
      expression: "formState.formName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "md": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "接收时间",
      "prop": "timeValue"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.formState.timeValue,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "timeValue", $$v);
      },
      expression: "formState.timeValue"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "md": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "类型",
      "prop": "category"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: _vm.formState.category,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "category", $$v);
      },
      expression: "formState.category"
    }
  }, _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateName
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  }), 1)], 1)], 1)], 1), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "申请流水号",
      "prop": "fillId"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "formatter": function formatter(value) {
        return "".concat(value);
      },
      "parser": function parser(value) {
        return value.replace('.', '');
      },
      "placeholder": "请输入申请流水号"
    },
    model: {
      value: _vm.formState.fillId,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "fillId", $$v);
      },
      expression: "formState.fillId"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "概述",
      "prop": "summary"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入概述"
    },
    model: {
      value: _vm.formState.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "summary", $$v);
      },
      expression: "formState.summary"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryTableList
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": _vm.cz
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('div', [_c('a-space', {
    staticClass: "operator"
  }), _c('a-table', {
    staticClass: "dictTable",
    attrs: {
      "customRow": _vm.rowClick,
      "data-source": _vm.dataSource,
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "size": "middle",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChangeTable
    },
    scopedSlots: _vm._u([{
      key: "formName",
      fn: function fn(formName, record) {
        return [_c('div', {
          ref: "csclaass",
          staticClass: "csclass"
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "确认取消跟踪该流程吗？",
            "ok-text": "是",
            "cancel-text": "否",
            "id": "btnn",
            "visible": _vm.visible && (record.processInstanceId || record.procInsId) == _vm.visibleId,
            "overlayClassName": "popBtn"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.handlepopConfirmConfirm(record);
            },
            "cancel": function cancel($event) {
              return _vm.handlepopConfirmCancel(record);
            },
            "visibleChange": function visibleChange($event) {
              return _vm.handleVisibleChange(record);
            }
          }
        }, [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.toSave(record);
            }
          }
        }, [record.trackStatus == 2 ? _c('img', {
          attrs: {
            "src": require("../../../assets/img/flag_red.png"),
            "alt": ""
          }
        }) : _c('img', {
          attrs: {
            "src": require("../../../assets/img/flag_grey.png"),
            "alt": ""
          }
        })])])], 1)];
      }
    }, {
      key: "dbFormName",
      fn: function fn(dbFormName, record) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "dblclick": function dblclick($event) {
              return _vm.dbTwoClick(record);
            }
          }
        }, [_vm._v(" " + _vm._s(record.formName) + " ")])];
      }
    }, {
      key: "status",
      fn: function fn(status, row) {
        return [_c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待　办")])];
      }
    }, {
      key: "cateType",
      fn: function fn(text, record) {
        return [_vm._v(" " + _vm._s(_vm.cateList.find(function (item) {
          return item.cateId == record.cateId;
        }).cateName) + " ")];
      }
    }, {
      key: "statusType",
      fn: function fn(text, record) {
        return [_c('a-tag', {
          attrs: {
            "color": record.status == 1 ? 'green' : 'red'
          }
        }, [_vm._v(" " + _vm._s(record.status == 1 ? '启用' : '停用') + " ")])];
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.onViewWaitMeApply(text, record);
            }
          }
        }, [_vm._v(" 查看 ")])], 1), _c('a-menu-item', [_c('a', {
          attrs: {
            "href": "javascript:;"
          }
        }), _c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.applyAudit(text, record);
            }
          }
        }, [_vm._v(" 审批 ")])], 1)], 1)], 1)];
      }
    }])
  })], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };